import React from 'react';
import {
  Container,
  LogoutIcon,
} from 'components/canvas/components/top-right-menu/style';
import LogoutConfirmationModal from 'components/canvas/components/top-right-menu/components/logout-confirmation-modal';
import { removeAdminToken } from 'services/storage';
import { useHistory } from 'react-router';

export default function TopRightMenu() {
  const modal = React.useRef<any>(null);
  const history = useHistory();

  function showLogOutModal() {
    modal.current.show();
  }

  function onConfirm() {
    removeAdminToken();
    history.push('/admin/login');
  }

  return (
    <>
      <LogoutConfirmationModal
        ref={modal}
        style={{ width: '30%', maxWidth: '780px' }}
        onConfirm={onConfirm}
      />
      <Container>
        <LogoutIcon onClick={showLogOutModal} />
      </Container>
    </>
  );
}
